import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const SaveChangesButton = ({addNew = false , isLoading = false}) => {
  return (
    <Row>
      <Col lg={4} xs={12}>
        <div className="form-group">
          <button type="submit" className="btn btn-blue">
          {isLoading? <FormattedMessage id={"loading"}/> : <FormattedMessage id={addNew ? "add" :"saveChanges"} />}  
          </button>
        </div>
      </Col>
    </Row>
  )
}

export default SaveChangesButton